var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNogasLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 488.05 119.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2,.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2{stroke:url(#linear-gradient);}.cls-3{stroke:url(#linear-gradient-2);}.cls-4{stroke:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 118.39,
    x2: 488.05,
    y2: 118.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#231f20",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#231f20",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#231f20",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#231f20",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 113.28,
    x2: 488.05,
    y2: 113.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 111.18,
    y1: 12.18,
    x2: 170.16,
    y2: 71.16,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Fill",
    "data-name": "Logo Fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.3,83.6a3,3,0,0,1-2.22-.91,3,3,0,0,1-.91-2.22V5.39a2.83,2.83,0,0,1,2.1-3,2.91,2.91,0,0,1,3.53,1L59.07,71.31V5.39A3.11,3.11,0,0,1,62.2,2.26a3.15,3.15,0,0,1,2.22.91,3.06,3.06,0,0,1,.91,2.22V80.47A3.19,3.19,0,0,1,62.2,83.6a3.06,3.06,0,0,1-2.5-1.2L7.43,14.55V80.47A3.11,3.11,0,0,1,4.3,83.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.68,83.6A39.34,39.34,0,0,1,227.9,71.71,39.31,39.31,0,0,1,216,42.93,39.29,39.29,0,0,1,227.9,14.15a40.78,40.78,0,0,1,57.56,0,3.15,3.15,0,0,1,0,4.43,3.16,3.16,0,0,1-4.44,0,34.48,34.48,0,0,0-48.68,0,33.16,33.16,0,0,0-10.07,24.35,33.12,33.12,0,0,0,10.07,24.34,34.43,34.43,0,0,0,47.77.86V46.06h-25a3.14,3.14,0,0,1-2.22-5.35,3,3,0,0,1,2.22-.91h28.09a3.11,3.11,0,0,1,3.13,3.13V69.49a3.13,3.13,0,0,1-.91,2.22A39.34,39.34,0,0,1,256.68,83.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.71,82.17a2.93,2.93,0,0,1-2.62,1.43H349.43a3.14,3.14,0,0,1-2.22-5.35,3,3,0,0,1,2.22-.91h35.89L357.27,13.18l-30,68.54a3.09,3.09,0,0,1-4.15,1.59,2.91,2.91,0,0,1-1.65-1.7,3,3,0,0,1,.06-2.39L354.37,4.14a3,3,0,0,1,2.9-1.88,2.86,2.86,0,0,1,2.85,1.88L393,79.22A2.84,2.84,0,0,1,392.71,82.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.15,77.34A15.64,15.64,0,0,0,480.79,61.7a15.62,15.62,0,0,0-15.64-15.64h-14.9a21.1,21.1,0,0,1-15.47-6.43,21.08,21.08,0,0,1-6.43-15.47,21.06,21.06,0,0,1,6.43-15.47,21.06,21.06,0,0,1,15.47-6.43h14.9a20.93,20.93,0,0,1,15.47,6.43,21.06,21.06,0,0,1,6.43,15.47,3,3,0,0,1-.91,2.22,3.06,3.06,0,0,1-2.22.91,3.19,3.19,0,0,1-2.22-.91,3.06,3.06,0,0,1-.91-2.22A15.54,15.54,0,0,0,465.15,8.52h-14.9a15,15,0,0,0-11,4.55,15.09,15.09,0,0,0-4.61,11.09,14.89,14.89,0,0,0,4.61,11,14.93,14.93,0,0,0,11,4.61h14.9a20.93,20.93,0,0,1,15.47,6.43,21.06,21.06,0,0,1,6.43,15.47,22,22,0,0,1-21.9,21.9h-14.9a22,22,0,0,1-21.9-21.9,3.14,3.14,0,0,1,5.35-2.22,3.06,3.06,0,0,1,.91,2.22,15.74,15.74,0,0,0,15.64,15.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_Stroke",
    "data-name": "Logo Stroke"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1,
    y1: 118.39,
    x2: 487.05,
    y2: 118.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 113.28,
    x2: 487.05,
    y2: 113.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.67,1a39.31,39.31,0,0,1,28.78,11.89,39.33,39.33,0,0,1,11.89,28.78,39.34,39.34,0,0,1-11.89,28.78,40.78,40.78,0,0,1-57.56,0A39.31,39.31,0,0,1,100,41.67a39.29,39.29,0,0,1,11.89-28.78A39.31,39.31,0,0,1,140.67,1Zm0,75.08A33.29,33.29,0,0,0,165,66a33.25,33.25,0,0,0,10.07-24.34A33.27,33.27,0,0,0,165,17.32a34.49,34.49,0,0,0-48.69,0,33.3,33.3,0,0,0-10.06,24.35A33.28,33.28,0,0,0,116.32,66,33.31,33.31,0,0,0,140.67,76.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNogasLogo);
export default __webpack_public_path__ + "static/media/nogas_logo.bb0e1862577d8fc80849bec8d6cc9680.svg";
export { ForwardRef as ReactComponent };